import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/theme/liga-logo-white.png'


const _hoisted_1 = { class: "logo" }
const _hoisted_2 = { class: "login-card-wrapper" }
const _hoisted_3 = { class: "main-button-container" }
const _hoisted_4 = { class: "signup-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_ion_content, {
        class: _normalizeClass('main-background'),
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "liga-logo"
            }, null, -1)
          ]))], 512), [
            [_vShow, _ctx.showLogo]
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_card, {
              class: _normalizeClass(['bg-transparent', _ctx.showLogo ? '' : 'half-screen-top'])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, { class: "ion-text-center white-bold" }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("АВТОРИЗАЦИЯ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      class: "bg-transparent",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Логин",
                          "label-placement": "floating",
                          fill: "solid",
                          type: "text",
                          modelValue: _ctx.loginData.username,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.username) = $event)),
                          disabled: _ctx.inlineLoading,
                          onIonFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInputFocus())),
                          autocomplete: "off",
                          autocorrect: "off",
                          onKeyup: _withKeys(_ctx.singIn, ["enter"])
                        }, null, 8, ["modelValue", "disabled", "onKeyup"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      class: "bg-transparent",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          label: "Пароль",
                          "label-placement": "floating",
                          fill: "solid",
                          type: "password",
                          modelValue: _ctx.loginData.password,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginData.password) = $event)),
                          disabled: _ctx.inlineLoading,
                          onIonFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInputFocus())),
                          autocomplete: "off",
                          autocorrect: "off",
                          onKeyup: _withKeys(_ctx.singIn, ["enter"])
                        }, null, 8, ["modelValue", "disabled", "onKeyup"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.singIn())),
                        disabled: _ctx.inlineLoading,
                        type: "submit"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("p", null, "Вход", 512), [
                            [_vShow, !_ctx.inlineLoading]
                          ]),
                          _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                            [_vShow, _ctx.inlineLoading]
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate('signup')))
                      }, "Регистрация"),
                      _createElementVNode("div", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigate('reset-password')))
                      }, "Забыли пароль?")
                    ]),
                    _createElementVNode("div", {
                      class: "not-authorized",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigate('today')))
                    }, "Пропустить")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.authenticated]
      ])
    ]),
    _: 1
  }))
}